import { useMap, useMapEvents } from "react-leaflet";

const MyComponent = ({
  radius,
  showAndHideTooltips,
  setToolTipIndex,
}) => {
  const map = useMap();
  const mapEvents = useMapEvents({
    zoomend: () => {
      const currentZoom = map.getZoom();
      if (currentZoom >= 10) {
        showAndHideTooltips(true); // Show tooltips when zoom is 10 or higher
      } else {
        showAndHideTooltips(false); // Hide tooltips when zoom is below 10
        setToolTipIndex(-1);
      }
    },
    zoom: (e) => {
      localStorage.setItem("zoom", mapEvents.getZoom());
      localStorage.setItem("lng", e.target.getCenter().lng);
      localStorage.setItem("lat", e.target.getCenter().lat);
    },
    dragend: (e) => {
      localStorage.setItem("lng", e.target.getCenter().lng);
      localStorage.setItem("lat", e.target.getCenter().lat);
    },
  });
  mapEvents.setZoom(radius);
  return null;
}

export default MyComponent;